import { NavLink, Outlet, useParams } from "react-router-dom";
import { useParcoursDetail } from "../../../hooks/useParcoursDetail";
import { useAuth } from "../../../auth/useAuth";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";

export default function ParcoursDetailLayout() {
  const { id = "" } = useParams<{ id: string }>();
  const { data, isLoading, isError } = useParcoursDetail(id);
  const { isAdmin } = useAuth();

  if (isLoading) return <div className="bo-loading">Chargement…</div>;
  if (isError || !data) return <div className="bo-error-text" style={{ textAlign: "center" }}>Parcours introuvable.</div>;

  const tabClass = ({ isActive }: { isActive: boolean }) => `bo-tabs__tab${isActive ? " is-active" : ""}`;

  return (
    <div>
      <PageHeader
        title={data.title}
        description={data.mainCommune ? `Commune principale : ${data.mainCommune}` : "Édition du parcours"}
        actions={
          <Button
            type="button"
            variant="ghost"
            onClick={() => {
              window.location.href = "/admin/parcours";
            }}
          >
            ← Tous les parcours
          </Button>
        }
      />

      <nav className="bo-tabs">
        <NavLink to={`/admin/parcours/${id}`} end className={tabClass}>
          Infos générales
        </NavLink>
        <NavLink to={`/admin/parcours/${id}/artists`} className={tabClass}>
          Artistes ({data.artists?.length ?? 0})
        </NavLink>
        <NavLink to={`/admin/parcours/${id}/lieux`} className={tabClass}>
          Lieux ({data.lieux?.length ?? 0})
        </NavLink>
        <NavLink to={`/admin/parcours/${id}/programmes`} className={tabClass}>
          Programmes ({data.programmes?.length ?? 0})
        </NavLink>
        {isAdmin && (
          <NavLink to={`/admin/parcours/${id}/members`} className={tabClass}>
            Membres
          </NavLink>
        )}
        {/* <NavLink to={`/admin/parcours/${id}/stats`} className={tabClass}>
          Statistiques
        </NavLink> */}
      </nav>

      <Outlet context={data} />
    </div>
  );
}
